module.exports = __webpack_public_path__ + "img/3.b02e9c50.png";